import { useEffect } from 'react';

interface ClarityConfig {
  clarityId: string;
}

export const Clarity = ({ clarityId }: ClarityConfig): null => {
  useEffect(() => {
    if (!clarityId) {
      console.warn('Clarity ID not provided');
      return;
    }

    // Check if Clarity is already loaded
    if (window.clarity) {
      console.log('Clarity already initialized');
      return;
    }

    // Initialize Clarity
    (function(c: any, l: Document, a: string, r: string, i: string) {
      c[a] = c[a] || function() {
        c[a].q = c[a].q || [];
        c[a].q.push(arguments);
      };
      const t = l.createElement(r) as HTMLScriptElement;
      t.async = true;
      t.src = "https://www.clarity.ms/tag/" + i;
      const y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", clarityId);

        console.log('Clarity Project ID:', clarityId ? clarityId.substring(0, 3) + '...' : 'Not Set');
  }, [clarityId]);

  return null;
};

// Extend Window interface for TypeScript
declare global {
  interface Window {
    clarity?: (...args: any[]) => void;
  }
}